import { translate } from "i18n/i18n";
import { TFunction } from "i18next";
import { ReactNode } from "react";
import {
  APP_LOGGING_API_MASTER_ROUTE,
  APP_USER_GROUPING_MASTER_ROUTE,
  APP_USER_GROUPING_PROJECT_PROFILE_MASTER_ROUTE,
  APP_USER_MASTER_ROUTE,
  MENU_REPORT_MASTER_ROUTE,
  ORGANIZATION_MASTER_ROUTE,
  DOCUMENT_PERMISSION_MASTER_ROUTE,
  PROJECT_AUTHORIZATION_REPORT_PREVIEW_ROUTE,
  RESPONSIBILITY_MASTER_ROUTE,
  ROLE_MASTER_ROUTE,
  EMAIL_REMINDER_CONFIG_MASTER_ROUTE,
  SITE_MASTER_ROUTE,
  USER_MANUAL_MASTER_ROUTE,
} from "./route-consts";

export interface Menu {
  name?: string | TFunction;
  icon?: string | ReactNode;
  link: string;
  externalLink?: string;
  children?: Menu[];
  active?: boolean;
  show?: boolean;
}

export const menu: Menu[] = [
  {
    name: translate("menu.title.appUser"),
    icon: "bx-user",
    link: "/app-user",
    active: false,
    show: true,
    children: [
      {
        name: translate("menu.title.appUser"),
        link: APP_USER_MASTER_ROUTE,
        active: false,
        show: true,
      },
      {
        name: translate("menu.title.appUserGrouping"),
        link: APP_USER_GROUPING_MASTER_ROUTE,
        active: false,
        show: true,
      },
      {
        name: translate("menu.title.folderPermissionGroup"),
        link: DOCUMENT_PERMISSION_MASTER_ROUTE,
        active: false,
        show: true,
      },
      {
        name: translate("menu.title.role"),
        link: ROLE_MASTER_ROUTE,
        active: false,
        show: true,
      },
      {
        name: translate("menu.title.responsibility"),
        link: RESPONSIBILITY_MASTER_ROUTE,
        active: false,
        show: false,
      },
      {
        name: translate("menu.title.organization"),
        link: ORGANIZATION_MASTER_ROUTE,
        active: false,
        show: true,
      },
    ],
  },

  {
    name: translate("menu.configuration"),
    icon: "bx-wrench",
    link: "/configurations",
    active: false,
    show: true,
    children: [
      // {
      //   name: translate("menu.loginConfiguration"),
      //   link: LOGIN_CONFIGURATION_MASTER_ROUTE,
      //   active: false,
      //   show: true,
      // },

      {
        name: translate("menu.sites"),
        link: SITE_MASTER_ROUTE,
        active: false,
        show: true,
      },
      {
        name: translate("menu.menuReport"),
        icon: "bx-paint",
        link: MENU_REPORT_MASTER_ROUTE,
        active: false,
        show: true,
      },
      {
        name: translate("menu.sendEmail"),
        link: EMAIL_REMINDER_CONFIG_MASTER_ROUTE,
        active: false,
        show: true,
      },
    ],
  },
  {
    name: translate("menu.title.logApi"),
    icon: "bx-user",
    link: "/logging-management/log-integration-api",
    active: false,
    show: true,
    children: [
      {
        name: translate("menu.title.viewApi"),
        link: APP_LOGGING_API_MASTER_ROUTE,
        active: false,
        show: true,
      },
    ],
  },
  {
    name: translate("menu.userManual"),
    icon: "bx-paint",
    link: USER_MANUAL_MASTER_ROUTE,
    show: true,
  },
  // {
  //   name: translate("menu.eap.configuration"),
  //   icon: "bx-wrench",
  //   link: INTEGRATION_EAP_CONFIGURATION_MASTER_ROUTE,
  //   active: false,
  //   show: true,
  // },
  {
    name: translate("projectAuthorizationReport.report"),
    icon: "bx-paint",
    link: PROJECT_AUTHORIZATION_REPORT_PREVIEW_ROUTE,
    active: false,
    show: true,
  },
  {
    name: translate("menu.title.appUserGroupingProjectProfile"),
    icon: "bx-group",
    link: APP_USER_GROUPING_PROJECT_PROFILE_MASTER_ROUTE,
    active: false,
    show: true,
  },
];
